export const FlickOColors = {
  primary: "#ff3e6c", // Radical Red
  success: "#22C55E",
  darkGreen: "#228B22",
  green: "#d4edda",
  red: "#f8d7da",
  white: "#FFFFFF",
  black: "#000000",
  blue: "#1E90FF",
  lightBlue: "#87CEFA",
  gray: {
    light: "#d3d3d3",
    medium: "#666666",
    dark: "#333333",
    dark2: "#696969",
    lighter: "#F1F5F9",
    lightest: "#F9FAFB", // Very light gray for backgrounds
  },
  text: {
    primary: "#333333",
    secondary: "#666666",
  },
  background: {
    light: "#FFFFFF",
    dark: "#F0F0F0",
  },
  error: "#FF0000",
};

export const FlickOTheme = {
  fontSizes: {
    small: 12,
    medium: 16,
    large: 20,
    xlarge: 24,
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 32,
  },
  borderRadius: {
    sm: 8,
    md: 12,
    lg: 16,
  },
};
